import { createRegisterableComponent } from '@news-mono/web-common'
import * as React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Unsubscribe } from './pages/Unsubscribe'

const queryClient = new QueryClient()

export const UnsubscribeEmailPreferenceRegistration =
    createRegisterableComponent(
        'email-preference-unsubscribe',
        (_, services) => {
            return (
                <QueryClientProvider client={queryClient}>
                    <Unsubscribe />
                </QueryClientProvider>
            )
        },
    )
